<template>
  <div class="alarm-page">
    <section class="query-card">
      <el-form :inline="true" :model="query" class="query-form" @submit.native.prevent>
        <el-form-item label="运单号">
          <el-input v-model.trim="query.transportNo" placeholder="请输入运单号" clearable @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input v-model.trim="query.vno" placeholder="请输入车牌号" clearable @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="query.createTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="timestamp"
          />
        </el-form-item>
        <el-form-item label="事件类型">
          <el-select v-model="query.alarmType" placeholder="请选择事件类型" clearable>
            <el-option v-for="item in alarmTypes" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="事件等级">
          <el-select v-model="query.alarmLevel" placeholder="请选择事件等级" clearable>
            <el-option label="紧急" :value="1" />
            <el-option label="普通" :value="2" />
            <el-option label="提示" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="query.handleStatus" placeholder="全部" clearable>
            <el-option label="未处理" :value="0" />
            <el-option label="已确认" :value="2" />
            <el-option label="已关闭" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="误报标记">
          <el-select v-model="query.falseAlarm" placeholder="全部" clearable>
            <el-option label="已标记误报" :value="true" />
            <el-option label="未标记误报" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item class="query-actions">
          <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <section class="list-card">
      <div class="list-toolbar">
        <div>
          <span class="list-title">告警消息</span>
          <span class="list-total">共 {{ total }} 条</span>
        </div>
        <div class="toolbar-actions">
          <el-button v-permission="'alarm:export'" icon="el-icon-download" :loading="exporting" @click="onExport">导出 Excel</el-button>
          <el-button v-permission="'alarm:edit'"
            type="warning"
            icon="el-icon-bell"
            :disabled="selectedRows.length !== 1 || !primaryAction(selectedRows[0])"
            @click="onBatchHandle"
          >确认 / 关闭</el-button>
          <el-button v-permission="'alarm:config'" icon="el-icon-setting" @click="onRuleSetting">告警设置</el-button>
          <el-tooltip content="刷新" placement="top">
            <el-button icon="el-icon-refresh" @click="fetchList" />
          </el-tooltip>
        </div>
      </div>

      <el-table
        v-loading="loading"
        :data="list"
        border
        stripe
        class="alarm-table"
        @selection-change="onSelectionChange"
      >
        <el-table-column type="selection" width="48" align="center" />
        <el-table-column prop="vehicleNo" label="车牌号" width="110" align="center" />
        <el-table-column prop="waybillNo" label="运单号" min-width="150" align="center" show-overflow-tooltip />
        <el-table-column label="事件类型" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="alarmTypeTag(row.alarmType)" size="small">{{ alarmTypeLabel(row.alarmType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="事件等级" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="alarmLevelTag(row.alarmLevel)" size="small">{{ alarmLevelLabel(row.alarmLevel) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="alarmRemark" label="事件内容" min-width="220" show-overflow-tooltip />
        <el-table-column prop="alarmAddress" label="事件地址" min-width="190" show-overflow-tooltip />
        <el-table-column prop="startAddress" label="起始地" min-width="190" show-overflow-tooltip />
        <el-table-column prop="targetAddress" label="目的地" min-width="190" show-overflow-tooltip />
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="{ row }">{{ row.createTime | fmt }}</template>
        </el-table-column>
        <el-table-column label="处理状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="Number(row.alarmFlag) === 2 ? 'info' : handleStatusTag(row.handleStatus)" size="small">
              {{ Number(row.alarmFlag) === 2 ? '解除记录' : handleStatusLabel(row.handleStatus) }}
            </el-tag>
            <el-tag v-if="row.falseAlarm" type="danger" size="small">误报</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="解除时间" width="160" align="center">
          <template slot-scope="{ row }">{{ row.endTime | fmt }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-permission="'alarm:edit'" v-if="primaryAction(row)" type="text" @click="onHandle(row)">{{ primaryAction(row) === 'CONFIRM' ? '确认' : '关闭' }}</el-button>
            <el-button v-permission="'alarm:edit'" v-if="Number(row.alarmFlag) !== 2 && !row.falseAlarm" type="text" @click="onHandle(row, 'MARK_FALSE_ALARM')">标记误报</el-button>
            <el-button type="text" @click="onHistory(row)">处理历史</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          background
          :current-page="page"
          :page-size="limit"
          :page-sizes="[15, 30, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="onSizeChange"
          @current-change="onPageChange"
        />
      </div>
    </section>

    <el-dialog :title="handleTitle" :visible.sync="handleVisible" width="460px" :close-on-click-modal="false" :show-close="!handling" :close-on-press-escape="!handling">
      <el-form :model="handleForm" label-width="82px">
        <el-form-item label="处理人">
          <el-input :value="operatorName" disabled />
        </el-form-item>
        <el-form-item label="处理说明">
          <el-input v-model.trim="handleForm.handleRemark" type="textarea" :rows="4" maxlength="256" show-word-limit placeholder="请输入处理说明" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button :disabled="handling" @click="handleVisible = false">取消</el-button>
        <el-button type="primary" :loading="handling" v-permission="'alarm:edit'" @click="onSubmitHandle">{{ handleTitle }}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="处理历史" :visible.sync="historyVisible" width="940px" @close="closeHistory">
      <el-table v-loading="historyLoading" :data="historyRows" border>
        <el-table-column label="操作" min-width="180"><template slot-scope="{ row }">{{ operationLabel(row.action) }}</template></el-table-column>
        <el-table-column label="处理状态" min-width="160"><template slot-scope="{ row }">{{ row.fromStatus == null ? '未记录' : handleStatusLabel(row.fromStatus) }} → {{ handleStatusLabel(row.toStatus) }}</template></el-table-column>
        <el-table-column label="误报标记" width="120"><template slot-scope="{ row }">{{ row.fromFalseAlarm == null ? '未记录' : (row.fromFalseAlarm ? '是' : '否') }} → {{ row.toFalseAlarm ? '是' : '否' }}</template></el-table-column>
        <el-table-column label="操作人" min-width="120"><template slot-scope="{ row }">{{ row.operatorName || row.operatorId || '未记录' }}</template></el-table-column>
        <el-table-column label="操作时间" width="160"><template slot-scope="{ row }">{{ row.operatedAt ? formatHistoryTime(row.operatedAt) : '未记录' }}</template></el-table-column>
        <el-table-column label="说明" min-width="160"><template slot-scope="{ row }">{{ row.remark || '未填写' }}</template></el-table-column>
      </el-table>
      <div class="pagination"><el-pagination :current-page="historyPage" :page-size="20" :total="historyTotal" layout="total, prev, pager, next" @current-change="onHistoryPage" /></div>
    </el-dialog>

    <alarm-rule-dialog ref="alarmRuleDialog" />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { exportAlarms, getAlarmList, getAlarmHistory, handleAlarm, isRequestSuccess } from './lingdongApi'
import AlarmRuleDialog from './AlarmRuleDialog.vue'
import { handleStatusLabel, handleStatusTag } from './alarmStatus'
import { authState } from '@/utils/auth'

const alarmTypes = [
  { label: '晚发', value: '1' },
  { label: '晚到', value: '2' },
  { label: '线路偏离', value: '3' },
  { label: '超时停车', value: '4' },
  { label: '在途离线', value: '5' },
  { label: '进入起始地围栏', value: '6' },
  { label: '驶出起始地围栏', value: '7' },
  { label: '进入目的地围栏', value: '8' },
  { label: '驶出目的地围栏', value: '9' },
  { label: '进入经停点', value: 'B' },
  { label: '驶出经停点', value: 'C' },
  { label: '进入途中围栏', value: 'D' },
  { label: '驶出途中围栏', value: 'E' },
  { label: '途中围栏区域内停车', value: 'F' },
  { label: '途中围栏驻留超时', value: 'G' },
  { label: '超速驾驶', value: 'H' },
  { label: '疲劳驾驶', value: 'I' }
]

function todayRange() {
  return [dayjs().startOf('day').valueOf(), dayjs().endOf('day').valueOf()]
}

export default {
  name: 'AlarmManage',
  components: { AlarmRuleDialog },
  filters: {
    fmt(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-'
    }
  },
  data() {
    return {
      alarmTypes,
      loading: false,
      listRequest: 0,
      exporting: false,
      list: [],
      total: 0,
      page: 1,
      limit: 15,
      query: {
        transportNo: '',
        vno: '',
        createTimeRange: todayRange(),
        alarmType: '',
        alarmLevel: null,
        handleStatus: null,
        falseAlarm: null
      },
      selectedRows: [],
      handleVisible: false,
      handling: false,
      handleForm: { id: null, action: '', handleRemark: '' },
      historyVisible: false,
      historyLoading: false,
      historyRequest: 0,
      historyAlarmId: null,
      historyRows: [],
      historyTotal: 0,
      historyPage: 1
    }
  },
  created() {
    this.fetchList()
  },
  computed: {
    handleTitle() { return { CONFIRM: '确认告警', CLOSE: '关闭告警', MARK_FALSE_ALARM: '标记误报' }[this.handleForm.action] || '告警操作' },
    operatorName() { return authState.user ? authState.user.username : '当前用户' }
  },
  beforeDestroy() {
    this.listRequest++
    this.historyRequest++
  },
  methods: {
    handleStatusLabel,
    handleStatusTag,
    primaryAction(row) {
      if (!row || Number(row.alarmFlag) === 2) return ''
      if (String(row.handleStatus) === '0') return 'CONFIRM'
      return String(row.handleStatus) === '2' ? 'CLOSE' : ''
    },
    buildQueryParams() {
      const params = {}
      if (this.query.transportNo) params.transportNo = this.query.transportNo
      if (this.query.vno) params.vno = this.query.vno
      if (this.query.alarmType) params.alarmType = this.query.alarmType
      if (this.query.alarmLevel !== null && this.query.alarmLevel !== '') params.alarmLevel = this.query.alarmLevel
      if (this.query.handleStatus !== null && this.query.handleStatus !== '') params.handleStatus = this.query.handleStatus
      if (this.query.falseAlarm !== null && this.query.falseAlarm !== '') params.falseAlarm = this.query.falseAlarm
      if (this.query.createTimeRange && this.query.createTimeRange.length === 2) {
        params.createTimeStart = this.query.createTimeRange[0]
        params.createTimeEnd = this.query.createTimeRange[1]
      }
      return params
    },
    async fetchList() {
      const requestId = ++this.listRequest
      this.loading = true
      try {
        const params = Object.assign({ page: this.page, limit: this.limit }, this.buildQueryParams())
        const res = await getAlarmList(params)
        if (requestId !== this.listRequest) return
        if (!isRequestSuccess(res)) {
          this.$message.error(res.msg || '查询失败')
          return
        }
        const data = res.data || {}
        this.list = data.items || []
        this.total = Number(data.total || 0)
        this.selectedRows = []
      } catch (e) {
        if (requestId === this.listRequest) this.$message.error((e && (e.msg || e.message)) || '告警消息查询失败')
      } finally {
        if (requestId === this.listRequest) this.loading = false
      }
    },
    async onExport() {
      this.exporting = true
      try {
        const response = await exportAlarms(this.buildQueryParams())
        const blob = response.data
        if (blob && blob.type && blob.type.includes('json')) {
          const content = await blob.text()
          let message = '导出失败'
          try {
            message = JSON.parse(content).msg || message
          } catch (e) { /* 忽略非 JSON 错误响应。 */ }
          throw new Error(message)
        }
        const disposition = response.headers && response.headers['content-disposition']
        const matched = disposition && /filename\*?=(?:UTF-8'')?["']?([^"';]+)/i.exec(disposition)
        const filename = matched && matched[1]
          ? decodeURIComponent(matched[1].trim())
          : `告警导出_${dayjs().format('YYYYMMDDHHmmss')}.xlsx`
        const url = URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = filename
        anchor.click()
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error((e && (e.msg || e.message)) || '导出失败')
      } finally {
        this.exporting = false
      }
    },
    onSearch() {
      this.page = 1
      this.fetchList()
    },
    onReset() {
      this.query = {
        transportNo: '',
        vno: '',
        createTimeRange: todayRange(),
        alarmType: '',
        alarmLevel: null,
        handleStatus: null,
        falseAlarm: null
      }
      this.page = 1
      this.fetchList()
    },
    onSizeChange(size) {
      this.limit = size
      this.page = 1
      this.fetchList()
    },
    onPageChange(page) {
      this.page = page
      this.fetchList()
    },
    onSelectionChange(rows) {
      this.selectedRows = rows
    },
    alarmTypeLabel(type) {
      const item = alarmTypes.find(option => option.value === String(type))
      return item ? item.label : type || '-'
    },
    alarmTypeTag(type) {
      if (['1', '2'].includes(String(type))) return 'warning'
      if (['3', 'H', 'I'].includes(String(type))) return 'danger'
      if (['4', '5'].includes(String(type))) return 'info'
      return 'success'
    },
    alarmLevelLabel(level) {
      return { 1: '紧急', 2: '普通', 3: '提示' }[Number(level)] || '-'
    },
    alarmLevelTag(level) {
      return { 1: 'danger', 2: 'warning', 3: 'info' }[Number(level)] || 'info'
    },
    onHandle(row, action) {
      if (!row || Number(row.alarmFlag) === 2 || this.handling) return
      const nextAction = action || this.primaryAction(row)
      if (!nextAction || (nextAction === 'MARK_FALSE_ALARM' && row.falseAlarm)) return
      this.handleForm = { id: row.id, action: nextAction, handleRemark: '' }
      this.handleVisible = true
    },
    onBatchHandle() {
      if (this.selectedRows.length === 1) this.onHandle(this.selectedRows[0])
    },
    async onSubmitHandle() {
      if (this.handling) return
      this.handling = true
      try {
        const payload = { id: this.handleForm.id, action: this.handleForm.action, handleRemark: this.handleForm.handleRemark.trim() }
        const res = await handleAlarm(payload)
        if (!isRequestSuccess(res)) {
          this.$message.error(res.msg || '处理失败')
          return
        }
        this.$message.success('处理成功')
        this.handleVisible = false
        this.fetchList()
        if (this.historyVisible && this.historyAlarmId === this.handleForm.id) this.fetchHistory()
      } catch (e) {
        this.$message.error((e && (e.msg || e.message)) || '告警处理失败')
      } finally {
        this.handling = false
      }
    },
    onHistory(row) {
      this.historyAlarmId = row.id
      this.historyPage = 1
      this.historyRows = []
      this.historyTotal = 0
      this.historyVisible = true
      return this.fetchHistory()
    },
    onHistoryPage(page) {
      this.historyPage = page
      return this.fetchHistory()
    },
    closeHistory() {
      this.historyRequest++
      this.historyLoading = false
    },
    async fetchHistory() {
      const requestId = ++this.historyRequest
      this.historyLoading = true
      try {
        const res = await getAlarmHistory({ id: this.historyAlarmId, page: this.historyPage, limit: 20 })
        if (requestId !== this.historyRequest) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '历史查询失败')
        this.historyRows = (res.data && res.data.items) || []
        this.historyTotal = Number((res.data && res.data.total) || 0)
      } catch (error) {
        if (requestId === this.historyRequest) this.$message.error((error && (error.msg || error.message)) || '历史查询失败')
      } finally {
        if (requestId === this.historyRequest) this.historyLoading = false
      }
    },
    operationLabel(action) {
      return { CONFIRM: '确认告警', CLOSE: '关闭告警', MARK_FALSE_ALARM: '标记误报', CONDITION_CLEARED: '条件解除', LEGACY_HANDLED: '历史已处理（按已关闭保留）' }[action] || action
    },
    formatHistoryTime(value) { return dayjs(value).format('YYYY-MM-DD HH:mm:ss') },
    onRuleSetting() {
      return this.$refs.alarmRuleDialog.open()
    }
  }
}
</script>

<style scoped>
.alarm-page { min-height: 100%; padding: 16px; box-sizing: border-box; background: #f4f6f9; color: #344054; }
.query-card, .list-card { padding: 18px 20px; border-radius: 8px; background: #fff; box-shadow: 0 1px 3px rgba(16, 24, 40, .04); }
.query-card { margin-bottom: 14px; }
.query-form { display: flex; flex-wrap: wrap; gap: 0 18px; }
.query-form ::v-deep .el-form-item { margin: 0 0 14px; }
.query-form ::v-deep .el-form-item__label { color: #475467; font-weight: 500; }
.query-form ::v-deep .el-input, .query-form ::v-deep .el-select { width: 200px; }
.query-form ::v-deep .el-date-editor { width: 370px; }
.query-actions { flex-basis: 100%; }
.list-toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.list-title { color: #1d2939; font-size: 17px; font-weight: 600; }
.list-total { margin-left: 10px; color: #98a2b3; font-size: 13px; }
.toolbar-actions { display: flex; gap: 8px; }
.toolbar-actions .el-button { margin: 0; }
.alarm-table { width: 100%; }
.alarm-table ::v-deep th { color: #475467; background: #f8fafc; }
.muted-text { color: #98a2b3; font-size: 13px; }
.pagination { display: flex; justify-content: flex-end; margin-top: 16px; }
@media (max-width: 1100px) {
  .alarm-page { min-width: 980px; }
}
</style>
